import React, { useState, useRef } from 'react'
import styles from './ControlSheetTextEntry.module.scss'
import clsx from 'clsx'
import ArrowRight from '../assets/arrow-right.svg'

interface Props {
    placeholder?: string
    onSubmit?: (text: string) => Promise<void>
    submitDisabled?: boolean
    disabled?: boolean
}

export const ControlSheetTextEntry: React.FC<Props> = ({
    placeholder = 'Enter your message...',
    onSubmit,
    submitDisabled,
    disabled,
}) => {
    const [text, setText] = useState('')
    const [isFocused, setIsFocused] = useState(false)
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    const handleSubmit = async () => {
        const trimmed = text.trim()
        if (trimmed.length > 0 && onSubmit) {
            setText('')
            await onSubmit(trimmed)
        }
    }

    const handleKeyPress = async (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            await handleSubmit()
        }
    }

    const handleFocus = () => {
        setIsFocused(true)
    }

    const handleBlur = () => {
        setIsFocused(false)
    }

    return (
        <div
            className={clsx(styles.textEntryWrapper, {
                [styles.textEntryWrapperFocussed]: isFocused,
            })}
        >
            <textarea
                ref={textareaRef}
                value={text}
                onChange={(e) => setText(e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur}
                onKeyPress={handleKeyPress}
                placeholder={placeholder}
                className={styles.textEntryInput}
                rows={1}
                disabled={disabled}
                maxLength={200}
            />
            <button
                onClick={handleSubmit}
                className={styles.submitButton}
                disabled={submitDisabled || disabled}
                type="button"
            >
                <ArrowRight />
            </button>
        </div>
    )
}

export default ControlSheetTextEntry
